import { Injectable, Type } from '@angular/core';
import { KeyValue } from '@angular/common';

import { ControlSpecification } from '../types/specification.types';
import { AssociatedDataEntity } from '../utils/specification-helper';
import { getDefaultControlSpecifications } from '../utils/specification-helper.default';
import { TextBoxPropertyEditorComponent } from '../property-editors';
import { DynamicFormDesignerConfig } from '../utils/dynamic-form-designer-config';

@Injectable({ providedIn: 'root' })
export class SpecificationHelperService {
  // designHostComponent: Array<Type<any>> = [];
  controlSpecifications: Array<ControlSpecification> = [];
  dataEntities: Array<AssociatedDataEntity> = [];
  propertyEditors: Array<KeyValue<string, Type<any>>> = [];

  constructor(config: DynamicFormDesignerConfig) {
    // this.designHostComponent.push(DesignHostComponent);
    this.controlSpecifications.push(...getDefaultControlSpecifications(this.dataEntities));
    this.propertyEditors.push(...[{ key: 'TextBox', value: TextBoxPropertyEditorComponent }]);
    // this.pushCustomControl(config.controlSpecifications);
    this.controlSpecifications = config.afterInit(this.controlSpecifications, this.dataEntities);
    this.validateControlSpecifications();
  }

  getControlSpecifications(): Array<ControlSpecification> {
    return this.controlSpecifications;
  }
  getDataEntities(): Array<AssociatedDataEntity> {
    return this.dataEntities;
  }
  getPropertyEditors(): Array<KeyValue<string, Type<any>>> {
    return this.propertyEditors;
  }

  addDefaultControlSpecifications(specifications: Array<ControlSpecification>) {
    this.controlSpecifications.push(...specifications);
  }

  clearDataEntities() {
    this.dataEntities.splice(0, this.dataEntities.length);
  }

  addDataEntities(dataEntities: Array<AssociatedDataEntity>) {
    this.dataEntities.push(...dataEntities);
  }

  /**
   * æ ¡éªè¯´æä¹¦
   *
   */
  private validateControlSpecifications(): void {
    this.controlSpecifications.forEach((s) => {
      if (this.controlSpecifications.filter((c) => s.name === c.name).length > 1) {
        throw new Error(`å­å¨éå¤åç§°æ§ä»¶`);
      }
    });
  }
}
